import type { Config } from '../types';

export const config: Config = {
  env: 'test',
  baseUrl: 'http://localhost:3000',
  apiURL: 'http://api-gateway-gql-service:4000/graphql',
};
